import { Box } from '@awaze/design-system.components.box';
import { pxToRems } from '@awaze/design-system.utils.react';
import styled from 'styled-components';
export const StyledImage = styled.img `
  position: absolute;
  height: 100%;
  width: 100%;
  inset: 0px;
  object-fit: cover;
`;
export const StyledImageContainer = styled.div `
  position: relative;
  height: 122px;
`;
export const StyledMicroPropertyCardContainer = styled.a `
  display: block;
  width: 100%;
  text-decoration: none;
  color: inherit;
`;
export const StyledPriceBox = styled(Box) `
  padding-right: ${pxToRems(12)};
`;
export const StyledWasSpan = styled.span `
  color: ${({ theme }) => theme.ColorStatusAttention400};
  font-size: 0.9rem;
  font-weight: 500;
  line-height: 1.25rem;
  text-decoration: line-through;
  margin: ${pxToRems(0)};
`;
export const StyledFromSpan = styled.span `
  color: ${({ theme }) => theme.ColorGrey700};
  font-size: ${({ theme }) => pxToRems(theme.FontTextText100MidFontSize)};
  margin: ${pxToRems(0)};
`;
export const GradeContainer = styled.div `
  margin-bottom: 0.3rem;
`;
export const StyledMoreInfo = styled.span `
  color: ${({ theme }) => theme.ColorThemeLink};
  text-decoration: underline;
`;
//# sourceMappingURL=micro-property-card-styles.js.map